import React                          from 'react';
import { WithStyle, withStyles }      from 'rewire-ui';
import { Theme }                      from '@material-ui/core/styles';
import DailyTimecardView              from '../../timecard/DailyTimecardView';
import timecardTestDailyTimecardModel from './TimecardTestDailyTimecardModel';

const styles = (_theme: Theme) => ({
});

type TimecardTestDailyTimecardProps = WithStyle<ReturnType<typeof styles>>;

class TimecardTestDailyTimecardView extends React.PureComponent<TimecardTestDailyTimecardProps> {
  constructor(props: TimecardTestDailyTimecardProps) {
    super(props);
  }

  render() {
    return (
      <DailyTimecardView model={timecardTestDailyTimecardModel} hideBatchStatus={true} hideTimecardStatus={true} disableComments={true} />
    );
  }
}

export default withStyles<unknown, unknown>(styles, TimecardTestDailyTimecardView);
